import { SVGProps } from 'react';

export const ChevronDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={9}
    viewBox="0 0 16 9"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.9079 2.16354L8.65788 8.41354C8.57078 8.50094 8.46729 8.57029 8.35333 8.6176C8.23938 8.66492 8.1172 8.68928 7.99381 8.68928C7.87042 8.68928 7.74825 8.66492 7.6343 8.6176C7.52034 8.57029 7.41685 8.50094 7.32975 8.41354L1.07975 2.16354C0.903631 1.98742 0.804687 1.74855 0.804688 1.49948C0.804688 1.25041 0.903631 1.01154 1.07975 0.835415C1.25587 0.659295 1.49474 0.560352 1.74381 0.560352C1.99289 0.560352 2.23176 0.659295 2.40788 0.835415L7.99459 6.42213L13.5813 0.834634C13.7574 0.658514 13.9963 0.55957 14.2454 0.55957C14.4944 0.55957 14.7333 0.658514 14.9094 0.834634C15.0856 1.01075 15.1845 1.24963 15.1845 1.4987C15.1845 1.74777 15.0856 1.98664 14.9094 2.16276L14.9079 2.16354Z"
    />
  </svg>
);
